import {
  types,
  ISavePreferenceAction,
  ISavePreferenceSuccessAction,
  IGetPreferencesAction,
  IGetPreferencesSuccessAction,
  IGetPreferencesFailureAction,
  IDeletePreferenceAction,
  IDeletePreferenceSuccessAction,
  ITransformedPreferenceResponseData,
  IUserGroupsPreferences,
} from '../types/userPreferences'

export const saveUserPreference = (
  groupId: string,
  fieldName: string,
  fieldValue: any,
  updateMode: boolean = false
): ISavePreferenceAction => ({
  type: types.SAVE_PREFERENCE__STARTED,
  groupId,
  fieldName,
  fieldValue,
  updateMode,
})

export const saveUserPreferenceSuccess = (
  groupId: string,
  preferenceData: ITransformedPreferenceResponseData
): ISavePreferenceSuccessAction => ({
  type: types.SAVE_PREFERENCE__SUCCESS,
  groupId,
  preferenceData,
})

export const getUserPreferences = (): IGetPreferencesAction => ({
  type: types.GET_PREFERENCES__STARTED,
})

export const getUserPreferencesSuccess = (
  userGroupsPreferences: IUserGroupsPreferences
): IGetPreferencesSuccessAction => ({
  type: types.GET_PREFERENCES__SUCCESS,
  userGroupsPreferences,
})

export const getUserPreferencesFailure = (): IGetPreferencesFailureAction => ({
  type: types.GET_PREFERENCES__FAILURE,
})

export const deleteUserPreference = (
  groupId: string,
  fieldName: string
): IDeletePreferenceAction => ({
  type: types.DELETE_PREFERENCE__STARTED,
  groupId,
  fieldName,
})

export const deleteUserPreferenceSuccess = (
  groupId: string,
  fieldName: string
): IDeletePreferenceSuccessAction => ({
  type: types.DELETE_PREFERENCE__SUCCESS,
  groupId,
  fieldName,
})
